var FlightMapSearch = (function ($) {
    FlightMapSearch = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options["$wrapper"];
        that.$form_wrapper = that.$wrapper.find('.js-flight-map-options');
        that.$direction_template = $('.js-direction-template');
        that.$load_more_wrapper = that.$wrapper.find(".js-load-more-wrapper");

        that.$departure_input = that.$wrapper.find(".js-departure");
        that.$arrival_input = that.$wrapper.find(".js-arrival");
        that.$swap_direction = that.$wrapper.find(".js-swap-direction");
        that.$show_connecting_flights_checkbox = that.$wrapper.find(
            ".js-flight-map-show-connecting-flights-checkbox"
        );
        that.$directions_list = that.$wrapper.find(".js-directions-list");

        // CONST
        that.locales = options["locales"] || {};
        that.airports = options["airports"] || {};
        that.departure = options["departure"] || undefined;
        that.arrival = options["arrival"] || undefined;
        that.show_connections = options["show_connections"] || 1;

        that.icon_types = {
            active: "active",
            inactive: "inactive",
            standard: "standard",
        };

        // INIT
        that.map = new UIYandexMapsWrapper(options, function () {
            that.init();
        });
    };

    FlightMapSearch.prototype.init = function () {
        var that = this;

        that.initElements();

        that.initWorker();

        that.initSwapDirection();

        that.disableEmptyLinks();
    };

    FlightMapSearch.prototype.initElements = function () {
        var that = this;

        // очищаем карту
        that.map.removeAllObjects();

        that.updateCitiesInMap();
        that.updateLinesInMap();

        // обновление списка направлений
        that.updateDirectionsInList();
    };

    FlightMapSearch.prototype.getIconType = function (airport = {}) {
        var that = this;

        // если нету выбранных городов разрешаем выбрать все
        if (!that.departure && !that.arrival) {

            // не может быть городом для вылета
            if (airport.to && !airport.to.length) {
                return that.icon_types.inactive;
            }

            return that.icon_types.standard;
        }

        // красим в оранжевый исходный город
        if (that.departure && that.departure.iata_code === airport.iata_code) {
            return that.icon_types.active;
        }

        // все возможные маршруты исходного города красим в синий
        if (
            that.departure &&
            that.departure.to?.indexOf(airport.iata_code) !== -1
        ) {
            return that.icon_types.standard;
        }

        // красим в синий город назначения
        if (
            !that.departure &&
            that.arrival &&
            that.arrival.iata_code === airport.iata_code
        ) {
            return that.icon_types.standard;
        }

        // если у нас нету варианта с исходным городом, но есть назначение
        if (
            !that.departure &&
            that.arrival &&
            that.arrival.from?.indexOf(airport.iata_code) !== -1
        ) {
            return that.icon_types.standard;
        }

        // остальные варианты помечаем неактивными
        return that.icon_types.inactive;
    };

    FlightMapSearch.prototype.addIconEventClick = function (
        icon,
        icon_type,
        airport
    ) {
        var that = this;

        icon.events.add("click", function () {
            // на неактивные города не можем нажать
            if (icon_type === that.icon_types.inactive) {
                return;
            }

            // двойным нажатием обнуляем выбор города
            if (icon_type === that.icon_types.active) {
                UISelect.prototype.__clearValue(that.$departure_input.closest('.select'))
                UISelect.prototype.__clearValue(that.$arrival_input.closest('.select'))

                return;
            }

            if (!that.departure) {
                that.$departure_input
                    .val(airport.iata_code)
                    .trigger("change")
                    .trigger("input");
            } else {
                that.$arrival_input
                    .val(airport.iata_code)
                    .trigger("change")
                    .trigger("input");
            }
        });
    };

    FlightMapSearch.prototype.addEventListenerToMap = function (close_element, onClick) {
        var el = document.getElementsByClassName(close_element) || [];
        el && el[0] && el[0].addEventListener('click', onClick, false);
        el && el[0] && el[0].addEventListener('touchstart', onClick, false);
    }

    FlightMapSearch.prototype.updateCitiesInMap = function () {
        var that = this;

        // показываем все города на карте
        for (const [key, airport] of Object.entries(that.airports)) {
            var icon_type = that.getIconType(airport);

            // добавляем стандартную иконку с хинтом и попапом
            var icon = that.map.addIcon(
                [airport.latitude_deg, airport.longitude_deg],
                {
                    hintContent: airport.city_name,
                },
                {
                    iconLayout: that.map.icons[icon_type],
                }
            );

            that.addIconEventClick(icon, icon_type, airport);

            if (
                that.departure &&
                that.departure.iata_code === airport.iata_code
            ) {
                var close_element_dep = 'close-' + that._randomString();

                that.map.addBalloon(
                    [airport.latitude_deg, airport.longitude_deg],
                    {
                        city_name: airport.city_name,
                        close: close_element_dep,
                    },
                    {
                        iconLayout: that.map.balloons.airplane_takeoff(),
                    }
                );

                setTimeout(function () {
                    var onCloseClick = function () {
                        UISelect.prototype.__clearValue(that.$departure_input.closest('.select'));
                    }
                    that.addEventListenerToMap(close_element_dep, onCloseClick);
                }, 200);
            }

            if (that.arrival && that.arrival.iata_code === airport.iata_code) {
                var close_element_arr = 'close-' + that._randomString(),
                    link_element = 'link-' + that._randomString();

                that.map.addBalloon(
                    [airport.latitude_deg, airport.longitude_deg],
                    {
                        city_name: airport.city_name,
                        close: close_element_arr,
                        link: link_element,
                        link_text: that.locales['find_ticket'],
                        use_button: Boolean(that.departure)
                    },
                    {
                        iconLayout: that.map.balloons.airplane_landing(),
                    }
                );

                setTimeout(function () {
                    var onCloseClick = function () {
                        UISelect.prototype.__clearValue(that.$arrival_input.closest('.select'));
                    }
                    that.addEventListenerToMap(close_element_arr, onCloseClick);

                    // для случая если нету города вылета
                    if (that.departure) {
                        var onLinkClick = function () {
                            window.location.href = that.departure?.links?.[airport.iata_code];
                        }
                        that.addEventListenerToMap(link_element, onLinkClick);
                    }
                }, 200);
            }
        }
    };

    FlightMapSearch.prototype.getRouteGeoCode = function (route) {
        var that = this;
        var geoCodes = [];

        for (const iata_code of route) {
            var airport = that.airports[iata_code];
            geoCodes.push([+airport.latitude_deg, +airport.longitude_deg]);
        }

        return geoCodes;
    };

    FlightMapSearch.prototype.updateLinesInMap = function () {
        var that = this;

        // для линий нужно два города
        if (!that.departure || !that.arrival) {
            return;
        }

        var to_with_routes =
            that.departure.to_with_routes?.[that.arrival.iata_code] || {};
        var routes = to_with_routes.routes || {};

        // рисуем линию между городами
        for (const [key, route] of Object.entries(routes)) {
            var geoCodes = that.getRouteGeoCode(route);
            var is_connecting_flight = geoCodes.length > 2;

            if (that.show_connections == 0 && is_connecting_flight) {
                continue;
            }

            async function drawRoute(geoCodes) {
                for (var i = 0, len = geoCodes.length - 1; i < len; i++) {
                    await that.map.addAnimatedLine(
                        [geoCodes[i], geoCodes[i + 1]],
                        {
                            hintContent:
                                that.departure?.city_name +
                                " - " +
                                that.arrival?.city_name,
                        },
                        {
                            strokeColor: that.map.strokeColors.main,
                            strokeStyle: is_connecting_flight
                                ? that.map.strokeStyle.dash
                                : undefined,
                            animationTime: 300,
                            strokeWidth: 2,
                            loopTime: 10,
                        }
                    );
                }
            }
            drawRoute(geoCodes);
        }
    };

    FlightMapSearch.prototype.updateDirectionsInList = function () {
        var that = this;

        that.$directions_list.empty();

        if (that.departure && that.arrival) {
            that.updateOneDirectionInList(that.departure, that.arrival);
        } else if (that.departure && Array.isArray(that.departure.to) && !that.arrival) {
            for (const iata_code of that.departure.to) {
                var airport = that.airports[iata_code];
                that.updateOneDirectionInList(that.departure, airport);
            }
        } else if (!that.departure && that.arrival && Array.isArray(that.arrival.from)) {
            for (const iata_code of that.arrival.from) {
                var airport = that.airports[iata_code];
                that.updateOneDirectionInList(airport, that.arrival);
            }
        }
    };

    FlightMapSearch.prototype.updateOneDirectionInList = function (
        departure,
        arrival
    ) {
        var that = this;

        // для направлений нужен хотя бы один город
        if (!departure || !arrival) {
            return;
        }

        var to_with_routes = departure.to_with_routes?.[arrival.iata_code] || {};
        var no_connecting_flights = Object.values(
            to_with_routes.routes || {}
        ).filter(function (route) {
            return route.length <= 2;
        });

        if (
            that.show_connections == 0 &&
            no_connecting_flights.length === 0
        ) {
            return;
        }
       
        var $direction = that.$direction_template.clone().show(),
            arrival_season = $.sa.parseSeason(departure.dates[arrival.iata_code]),
            arrival_image = arrival.images[arrival_season];
        
        $direction.attr('href', departure.links?.[arrival.iata_code])
        $direction.find('.direction-to').text(departure.city_name);
        $direction.find('.direction-from').text(arrival.city_name);
        $direction.find('.direction-img').css('background-image',`url(${arrival_image})`);
        
        var price = departure.prices?.[arrival.iata_code];
        if(price) {
            $direction.find('.direction-price-number').text(departure.prices?.[arrival.iata_code]);
        } else {
            $direction.find('.direction-price').text(that.locales['find_cost']).addClass('unknown link none');
        }
        
        that.$directions_list.append($direction);
    };

    FlightMapSearch.prototype.initPagination = function () {
        var that = this,
            url = new URL(window.location.href);
        $.sa.pagination(that.$wrapper, url.toString());
    };

    FlightMapSearch.prototype.disableEmptyLinks = function () {
        var that = this;

        that.$wrapper.find("a[href*='#']").on("click", function (event) {
            event.preventDefault();
        });
    };

    FlightMapSearch.prototype._randomString = function () {
        return Math.random().toString(36).substring(3, 9);
    }

    FlightMapSearch.prototype._updatePageWithNewSearchParams = function (
        params
    ) {
        var that = this;
        var url = new URL(window.location.href);

        $.each(params, function (index, value) {
            // TODO: нужно ли удаление?
            url.searchParams.set(index, value.toString());
        });

        // Обновляем url с новыми параметрами
        history.pushState({}, "", url);

        // Обновляем элементы на странице
        that.initElements();
    };

    FlightMapSearch.prototype.initWorker = function () {
        var that = this;

        that.$departure_input.on("change", function () {
            var query = $.trim(that.$departure_input.val().toLowerCase());
            var param_name = that.$departure_input.attr("name") ?? "departure";

            that.departure = that.airports[that.$departure_input.val()];

            // Если в выбранный город назначения нет перелетов
            if (that.departure && !that.departure.to_with_routes?.[that.$arrival_input.val()]) {
                UISelect.prototype.__clearValue(that.$arrival_input.closest('.select'))
            }

            that._updatePageWithNewSearchParams({
                [param_name]: query,
            });
        });

        that.$arrival_input.on("change", function () {
            var query = $.trim(that.$arrival_input.val().toLowerCase());
            var param_name = that.$arrival_input.attr("name") ?? "arrival";

            that.arrival = that.airports[that.$arrival_input.val()];

            that._updatePageWithNewSearchParams({
                [param_name]: query,
            });
        });

        that.$show_connecting_flights_checkbox.on("change", function () {
            $_changed_element = $(this);
            var query = $_changed_element.prop("checked") ? 1 : 0;
            var param_name =
                that.$show_connecting_flights_checkbox.attr("name") ??
                "show_connecting_flights";

            that.show_connections = query;

            that._updatePageWithNewSearchParams({
                [param_name]: query,
            });
        });
    };

    FlightMapSearch.prototype.initSwapDirection = function () {
        var that = this;

        that.$swap_direction.on("click", function () {
            var allowed = !that.$swap_direction.attr("disabled");

            if (allowed) {
                var departure_code = that.$departure_input.val(),
                    arrival_code = that.$arrival_input.val();

                that.$departure_input.val("");
                that.$arrival_input.val("");

                setTimeout(function () {
                    that.$departure_input.val(arrival_code).trigger("change");
                    that.$arrival_input.val(departure_code).trigger("change");
                    // TODO фокус на поле $arrival_input = that.$arrival_input.parents('div.select').first().find('input[type=text]')
                }, 0);
            }
        });

        // валидация возможности обратных рейсов
        var swap_available = function () {
            var arrival_code = that.$arrival_input.val(),
                departure_code = that.$departure_input.val(),
                $select = that.$arrival_input.parents("div.select").first(),
                $selected = $select
                    .find(
                        '.select-options .option[data-value="' +
                            arrival_code +
                            '"]'
                    )
                    .first(),
                to = $selected.data("to") || [],
                swap_available =
                    departure_code &&
                    arrival_code &&
                    to.indexOf(departure_code) !== -1;
            // some glitches at select, so swap available only on filled fields

            that.$swap_direction.attr("disabled", swap_available ? null : true);
        };

        that.$arrival_input.on("change", swap_available);
        that.$departure_input.on("change", swap_available);

        // подфильтрация направлений
        var filter_arrival = function () {
            var departure_code = that.$departure_input.val(),
                selected_arrival_code = that.$arrival_input.val(),
                arrival_code_available = false,
                $select = that.$arrival_input.parents("div.select").first(),
                $arrival_input = $select.find("input[type=text]");

            $select.find(".select-options .option").map(function () {
                var $option = $(this),
                    from = $option.data("from") || [],
                    arrival_code = $option.data("value"),
                    is_hidden =
                        departure_code && from.indexOf(departure_code) === -1;

                $option.data("hidden", is_hidden);
                if (is_hidden) {
                    $option.hide();
                } else {
                    if (arrival_code === selected_arrival_code) {
                        arrival_code_available = true;
                    }
                    $option.show();
                }
            });

            if (!arrival_code_available) {
                $arrival_input.val("");
            }
        };
        that.$departure_input.on("change", filter_arrival);

        // инициализация
        swap_available();
        filter_arrival();
    };

    return FlightMapSearch;
})($);
